export default __webpack_public_path__ + "static/media/ico-opportunities.0e232bc4.svg";